import 'bootstrap';

(function () {
  let pagefind = null;

  document.addEventListener('DOMContentLoaded', function () {
    const searchModal = document.getElementById('search-modal');

    searchModal.addEventListener('shown.bs.modal', function () {
      if (!pagefind) {
        pagefind = new PagefindUI({
          element: '#search',
          autofocus: true,
          sort: {
            //date: "desc",
            weight: "asc",
          }
        });
      }
    });

    searchModal.addEventListener('hidden.bs.modal', function () {
      if (pagefind) {
        pagefind.destroy();
        pagefind = null;
      }
    });
  });
})();
